import React, { useEffect, useRef } from "react";
import "../styles/contactcard.css";
import VanillaTilt from "vanilla-tilt";
import { useAudio } from "./AudioContext";

export default function ContactCard({ icon, text, top, top2 }) {
  const tiltRef = useRef(null);
  const { isMobile } = useAudio();

  useEffect(() => {
    if (tiltRef.current) {
      VanillaTilt.init(tiltRef.current, {
        scale: 1.1,
        max: 25,
        speed: 400,
        glare: true,
        "max-glare": 1,
      });
    }
  }, []);
  return (
    <div ref={tiltRef} className="card" style={{ top: isMobile ? top2 : top }}>
      <i className={icon}></i>
      <p>{text}</p>
    </div>
  );
}
